/* eslint-disable react-hooks/exhaustive-deps */


import React,{useEffect,useRef,useCallback} from 'react';
import { useTranslation } from 'react-i18next';
import '../../../../assets/styles/styles.scss';
import {downloadReportOptions,MIMETypes} from "../../../../utils/configs";
import { updateButtonTxtStatus,onDownloadCSVFile,formatDateByTimezone} from '../../../../utils/commonFunctions';
import { APIEndpoint, DFPAPIEndpoint } from "../../../../utils/axios";
import {Authorizer} from 'casbin.js';
import { NGODatePicker,EditModal} from "../../../../common";
import CustomSelect from "../../../../common/CustomSelect";
import closeIcon from '../../../../images/icons/Icon2.png';
import LoadingIn from '../../../../assets/loadingIn.gif';
import AllMultiSelect from "../../../../common/AllSelectCheckbox.jsx";
import downloadMasterIcon from '../../../../assets/icons/download-master.svg';
import { components } from "react-select";
import usePermissions from '../../../../utils/userPermissions';
import moment from 'moment';
import Select from 'react-select';
import {
  SalesReportsDownloadComponent
} from "../../../sales/inner-components/renderers";
import * as ReactDOM from "react-dom";
import { useState } from 'react';

let prevMenu = null;

export const ReportsPage = (props) => {
  const { t ,ready} = useTranslation();
  const [isDownloading,setIsDownloading]=useState(false);
  const [state,setState]=useState({disabled:false,filterPrice:null});
  const [sectors,setSectors]=useState([]);
  const[showUpload, setShowUpload]= useState(false);
  const [reportDownloadErr, setReportDownloadErr] = useState(null);
  const modelStyle = { maxWidth: '80%' };
  const [modalFormStatusObj, setModalFormStatusObj] = useState({ text: '' });
  const [editFormFields, setEditFormFields] = useState([]);
  const [ modalTitle, setModalTitle ] = useState('View Purchase Order Items');
  const [sectorList, setSectorsList] = useState([]);
  const [reportsType, setReportTypes] = useState([]);
  const [rowsWithBorderBottom,setRowsWithBorderBottom]=useState([]);
  const [optionSelectedCrew,setOptionSelectedCrew]=useState(null);
  const [optionSelectedSector,setOptionSelectedSector]=useState(null);
    const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [reptType,setReptType]=useState("");
  const [modalCustomButtons, setModalCustomButtons] = useState(null);
  const [, setUpdatedFormFieldValues] = useState({});
  const [stores, setStores] = useState([]);
  const[reportsSelected,setReportSelected]=useState("");
  const [reportOptionsFiltered, setReportOptionsFiltered] = useState([]);
  const [storeType,setStoreType]=useState([]);
const [reportDate,setReportDate]=useState({startDate:"",endDate:""});
const [showDownload,setShowDownload]=useState(false);
  const [warehouses, setWarehouses] = useState([]);
  const [items, setItems] = useState([]);
  const [permissionObj,setPermissionObj]=useState({});
  const [reptTypeCash,setReptTypeCash]=useState('');
  const [reptTypeProcurement,setReptTypeProcurement]=useState('');
  const [modalFormData, setModalFormData] = useState({});
  const [selWarehouse, setSelWarehouse] = useState('');
  const [crewName,setCrewName]=useState("");
  const [reportTypes, setReportTypesWareHouse] = useState([]);
  const [,setResponse]=useState(null);
  const [isDownloadPressed,setIsDownloadPressed]=useState(false);
  const [crewMembers,setCrewMembers]=useState([]);
  const [estimateDate, setEstimateDate] = useState(new Date());
  const sType = localStorage.getItem('sType');
  const [priceLists,setPriceLists]=useState([]);
  const [cursorDisabled,setCursorDisabled]=useState(false);
  const markerRef = useRef(null);
    const [authorizer] = useState(new Authorizer('manual'));
    const hostType = localStorage.getItem('sType');
    const userRole = localStorage.getItem('userRole')
    const permissions=localStorage.getItem("userPermissions");
  const DOMAIN = (sType === 'dfp' ? DFPAPIEndpoint : APIEndpoint);

  
  const { hasPermission: downloadReports } = usePermissions('download', "portal.menu.reports");
  const { hasPermission: viewReports } = usePermissions('view', "portal.menu.reports");

  let timeout=useRef(null);

  const ReportFields = [
    { label: 'Report Type', attribute: 'reportType', type: 'select', required: true,disabled:true },
    { label: 'Start Date', attribute: 'startDate', type: 'date', required: true,value:new Date(moment()),maxDate:new Date(moment())},
    { label: 'End Date', attribute: 'endDate', type: 'date', required: true ,value:new Date(moment()),maxDate:new Date(moment())},
  ]
  const [reportsFields, setReportFields] = useState(ReportFields||[]);

useEffect(() => {
  if(!reportTypes.length || !warehouses.length || !sectorList.length || !items.length){
  loadReportTypes();
  getWarehouses();
  getSectorList();
  getAllItems();

  }
}, [])

useEffect(() => {
  if (hostType && userRole && permissions) {
    try {
      const permissionsObject = JSON.parse(permissions);
      if (permissionsObject[userRole]) {
        authorizer.setPermission(permissionsObject[userRole]);
      }
    } catch (e) {
      console.error(e);
    }
  }
}, [hostType, userRole, permissions,ready]);

useEffect(() => {
  if (authorizer?.permission) {
    setPermissionObj(authorizer.permission);
  }
}, [authorizer?.permission]);

useEffect(() => {
  if (!permissionObj) return;

  const actObjData = permissionObj.actObjData;
  if (!actObjData) return;

  const downloadResources = actObjData.get('download');
  if (!downloadResources?.length) return;

  const filteredReports = downloadReportOptions.filter(rept =>
    downloadResources.includes(rept.permission)
  );
  let indexArr = [];
  let previousMenu = null;

  filteredReports.forEach((flt, index) => {
    if (previousMenu && flt.menu !== previousMenu) {
      indexArr.push(index);
    }
    previousMenu = flt.menu;
  });
  

setRowsWithBorderBottom(indexArr);

  setReportOptionsFiltered(filteredReports);
  renderTableRows();
}, [permissionObj, downloadReportOptions,ready]);

useEffect(() => {
  if(cursorDisabled){
   timeout.current = setTimeout( () => {
      setCursorDisabled(false);
      clearTimeout(timeout.current);
  }, 7000 );
  }
  return ()=>clearTimeout(timeout.current);
}, [cursorDisabled])

useEffect(() => {
  if (
    modalFormData && isDownloadPressed &&
    state?.selected &&
    (state.selected.action === "downloadPOReportsPopup" || state.selected.action === "Suspend") &&
    reportsSelected
  ) {
    const action = state.selected.action;
    modalFormData.reportType=reportsSelected;
    validateFormInputs(modalFormData, action);
  }
}, [modalFormData, state, reportsSelected]);


useEffect(() => {
  if(reportsType.length && reportsSelected.length){
    setReptType(reportsType.find(rpt=>rpt.label===reportsSelected)?.value)
  }

}, [reportsType,reportsSelected])

useEffect(() => {
  if(state&&state.cashReportTypes&&state.cashReportTypes.length){
    const reportsCash=state.cashReportTypes.find(rpt=>rpt.label===reportsSelected)?.value
    if(reportsCash==="cashierBankTransferReport"){
      handleOnchangeReports(null,{reportType:"cashierBankTransferReport"},null)
         }else{
          setReportFields(ReportFields)
         }
    setReptTypeCash(reportsCash)
  }

}, [reportsSelected,state])

useEffect(() => {
  if(state&&state.selected&&reportTypes.length){
    setReptTypeProcurement(reportTypes.find(rpt=>rpt.label===reportsSelected)?.value)
  }
  if(state.showActionDialog==='report'){
    setReportFields((prev)=>{
      return prev?.map((_) => {
        if(_.label ==='End Date'){
          return { ..._, minDate:new Date(ReportFields[1].value), }

        }
        else {
          return { ..._,}
        }
      })
    })
  }

}, [reportsSelected,reportTypes,state])

useEffect(() => {
  const updateDisabledState = () => {
    if (!reptType) return true;

    switch (reptType) {
      case 'crewCommission':
      case 'crewVariance':
      case 'crewReconVariance':
      case 'customerInteractionsReport':
      case 'upliftReport':
      case 'offloadSummaryAggregate':
      case 'sandboxSalesSummary':
      case 'sandboxInvoiceSummary':
      case 'mealRefusedReport':
      case 'upliftAuditReport':
        return (Boolean(reportDate.startDate) && Boolean(reportDate.endDate))? false:true
        case 'sandboxSectorSalesReport':
          case 'sandboxFlightRoutesReport':
            case 'inventorySnapshot':
              case 'allCrewCommission':
              case 'groupWiseInventorySnapshot':
                  case 'consignmentFillup':
                  case 'consignmentSales':
                    case 'consignmentReturns':
        return (Boolean(reportDate.startDate) && Boolean(reportDate.endDate))? false:true
  case 'Vendor Mapping Report':
    case 'Price Master Report':
  return selWarehouse && typeof selWarehouse==='object'? false:true
      default:
        return true;
    }
  };

  setState((_prev) => ({
    ..._prev,
    disabled: updateDisabledState(),
  }));
  if(optionSelectedCrew && optionSelectedCrew?.length){
    if( optionSelectedCrew.filter(opt=>opt.value==='*').length){
      setOptionSelectedCrew([{key:null,label:`All ${crewMembers.length-1} selected`,value:crewMembers?.map((item)=>item.key.toString()).filter(item=>item!=='0')}])
    }
   }
   if(optionSelectedSector && optionSelectedSector?.length){
    if( optionSelectedSector.filter(opt=>opt.value==='*').length){
      setOptionSelectedSector([{key:null,label:`All ${optionSelectedSector.length-1} selected`,value:sectors?.map((item)=>item.value.replace(/\s+/g, '')).filter(item=>item!=="")}])
    }
   }
}, [reptType, crewName, reportDate,optionSelectedCrew, storeType,optionSelectedSector,selWarehouse]);

const getOptions=(cMemb)=>{

  return cMemb.filter(a=>a.value);


}

const handleMenuOpen = () => {
setIsDropdownOpen(true);
};

const handleMenuClose = () => {
setIsDropdownOpen(false);
};


    const preCompile = {
      warehouse: 'Warehouse',
      selectWarehouses: 'Select Warehouses',
      selectReportType: 'Select Report Type',
  };

  const getMenuGroups = (m) => {
    if (prevMenu === m) {
      return '';
    }
    prevMenu = m;
      return m;

  };
  const Option = props => {
    return (
    <div>
    <components.Option {...props}>
    <input
    type="checkbox"
    checked={props.isSelected}
    onChange={() => null}
    />{" "}
    <label>{props.label}</label>
    </components.Option>
    </div>
    );
    };

  const MultiValue = props => (
    <components.MultiValue {...props}>
    <span>{props.data.label}</span>
    </components.MultiValue>
    );

    const customStyles = {
      input: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
      }),
      control: (defaultStyles) => ({
        ...defaultStyles,
        backgroundColor: "#162E3E",
        padding: "2px",
        width: '17rem',
        marginTop: '0.5rem',
        border: "0.4px solid #FFFFFF",
        boxShadow: "none",
      }),
      option: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
        backgroundColor: '#162E3E',
        textAlign: 'left',
      }),
      singleValue: (defaultStyles) => ({
        ...defaultStyles,
        color: '#fff',
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        textAlign: 'left',
      })
    };


  const newCustomStyles = {
    input: (defaultStyles) => ({
      ...defaultStyles,
      color: '#fff',
      }),
      control: (defaultStyles) => ({
        ...defaultStyles,
        backgroundColor: "#162E3E",
        padding: "2px",
        width:'17rem',
        marginBottom: '1rem',
        border: "0.4px solid #FFFFFF",
        boxShadow: "none",
        PointerEvent: 'none',
      }),
      option: (defaultStyles) => ({
        ...defaultStyles,
        textAlign: 'left',
      }),
      placeholder: (defaultStyles) => ({
        ...defaultStyles,
        textAlign: 'left',
      })
  };

   const onDownloadReports=async(m)=>{
const {menu,reportsType,disabled,subReport}=m;

  if(disabled){
  return null
  }

switch (menu) {
  case "Finalized Sales":
    setReportSelected(reportsType)
     onDownloadReconciled();
    break;
    case "Synced Sales":
      if(subReport){
        setCursorDisabled(true);
        onDownloadActivityReport();
      }else{
        setReportSelected(reportsType)
         onDownloadReport(menu)
      }
      break;
      case "Offload Summary":
        setReportSelected(reportsType)
       onDownloadReport(menu)
        break;
         case "Uplifts":
        setReportSelected(reportsType)
       onDownloadReport(menu)
        break;
        case "ERP Report":
          setReportSelected(reportsType)
         onDownloadReport(menu)
          break;
       case "Cash register":
        setReportSelected(reportsType)
        handleDownloadReportBtn();
      break;
         case "Configuration":
          if(reportsType==='Price Master Report'){
               const priceListAvailable= await fetchPriceList();
               if(priceListAvailable){
                   setReptType(reportsType);
                    setShowUpload(true);
               }
          }else{
            onDownloadItemMaster(reportsType);
            setCursorDisabled(true);
          }          
      break;
       case "Inventory":
        if(reportsType==='Vendor Mapping Report'){
            setReptType(reportsType);
            setShowUpload(true);
        }else if(reportsType==='Price Master Report'){
               const priceListAvailable= await fetchPriceList();
               if(priceListAvailable){
                   setReptType(reportsType);
                    setShowUpload(true);
               }
          }
        else{
       onDownloadItemMaster(reportsType);
      setCursorDisabled(true);
        }
      
      break;
      case "Administration":
       onDownloadItemMaster(reportsType);
      setCursorDisabled(true);
      break;
      case "Price Master":
        onDownloadPriceList();
      break;
      case "Combos":
        onDownloadCombo();
      break;
      case "Vendor Mapping":
        onDowloadVendorMapping();
      break;
      case "Procurement":
        setReportSelected(reportsType)
        onDownLoadPurchaseOrders(reportsType);
        loadReportTypes();
      break;
      case "Employees":
        onDownloadUsers();
      break;
          case "Crew Performance":
            if(reportsType==='Active Users Report'){
                onDownloadItemMaster(reportsType);
                setCursorDisabled(true);
            }else{
              setReportSelected(reportsType)
                  onDownloadReport(menu);
                  getCrewDetails();
            }
                break;

      case "Sectors":
        onDownloadSectors();
      break;
      case "Vendors":

      break;
       case "Distributors":
        onDownloadDistributors();
      break;
      case "Devices Activity":

        break;
        case "Aircraft Operation Status":
        onDownloadAircraftOpn()
          break;
  default:
    break;
}
   }
   const onStoreChange=(e)=>{
    if(reptType==="sandboxSalesSummary"||reptType==="sandboxInvoiceSummary"||reptType==="offloadSummaryAggregate"||reptType==="mealRefusedReport"||reptType==="upliftAuditReport"||reptType==='upliftReport'){
        setStoreType([e])

    }
    else{
        setStoreType([])

    }
}

const onCrewChange=(e)=>{
  if(reptType==="crewCommission"||reptType==="crewVariance" ||reptType==="crewReconVariance"){
      setCrewName([e])

  }
  else{
      setCrewName([])

  }
}

function getCrewName(crew){
  const [crewOrg] = crew
  if(crewOrg?.value){
    return [crewOrg?.value]
  }else{
    return [crewOrg]
  }
}

const onDateChangeRep=(e)=>{
  const {name,value}=e.target;
  if(name==='startDate'){
      setReportDate((prev)=>({...prev,startDate:value}))
  }
  else{
      setReportDate((prev)=>({...prev,endDate:value}))
  }
  }
  const onReportTypeChange = (e) => {
    setReptType(e.target.value);
}

   const onDownloadReconciled= async (e) => {
    const action = { value: "downloadReportPopup" };
    onActionInnerRecon(e, action, {});
  };

   const onDownLoadPurchaseOrders = (reportName=null) => {
   !reportName? onActionInner({value: 'downloadPOReportsPopup'}, {}):onActionInner({value: 'downloadPOReportsPopup'},reportName);

}

const onDowloadVendorMapping=()=>{
  onActionInnerVendMapp({value: 'vendorMapping'}, {});
}

const onActionInnerRecon = (e, action, row) => {

  ReactDOM.flushSync(() => {
    // let updatedEditFields = [];

   if (action.value === "downloadReportPopup") {
      setState((_prev) => {
        return { ..._prev, selected: { ...row, action: action.value } };
      });
    }
  });
};

const onDownloadReport=async(type)=>{
  setCursorDisabled(true);
  if(type==="Synced Sales"){
    try {
      const resp = await DOMAIN.get('reports/sandboxReportTypes');
      if (resp.result.length > 0) {
          const options = [{key: 0, label: "Select Report Type", value: ''}];
          resp.result.filter( (fieldValue, index) => {
            options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
            return fieldValue;
          });
          setReportTypes(options);
      }
      else{
          console.log("error")
      }


      const respStore = await DOMAIN.get('stores');
      if (respStore.result.length > 0) {

          const options = [{key: 0, label: "Select Route", value: ''}];
          respStore.result.filter( (fieldValue, index) => {
            options.push({key: index+1, label: `${fieldValue.flightNumber} (${fieldValue.originName}-${fieldValue.destinationName})`, value: `${fieldValue.id}`});
            return fieldValue;
          });
          setStores(options);
      }
      else{
          console.log("error")
      }


  } catch (error) {

  }

}
else if(type==='Offload Summary'){
  try {
    const resp = await DOMAIN.get('reports/offloadReportTypes');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: "Select Report Type", value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setReportTypes(options);
    }
    else{
        console.log("error")
    }


    const respStore = await DOMAIN.get('stores');
    if (respStore.result.length > 0) {

        const options = [{key: 0, label: "Select Route", value: ''}];
        respStore.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.flightNumber} (${fieldValue.originName}-${fieldValue.destinationName})`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setStores(options);
    }
    else{
        console.log("error")
    }


} catch (error) {

}
}
else if(type==='Uplifts'){
  try {
    const resp = await DOMAIN.get('reports/upliftReportTypes');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: "Select Report Type", value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setReportTypes(options);
    }
    else{
        console.log("error")
    }

    const respStore = await DOMAIN.get('stores');
    if (respStore.result.length > 0) {

        const options = [{key: 0, label: "Select Route", value: ''}];
        respStore.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.flightNumber} (${fieldValue.originName}-${fieldValue.destinationName})`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setStores(options);
    }
    else{
        console.log("error")
    }


} catch (error) {

}
}
else if (type==='ERP Report'){
  try {
    const resp = await DOMAIN.get('reports/sapReportTypes');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: "Select Report Type", value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setReportTypes(options);
    }
    else{
        console.log("error")
    }

} catch (error) {

}
}
else if(type!=='Crew Performance'){
  try {
    const resp = await DOMAIN.get('reports/reportTypes');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: "Select Report Type", value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setReportTypes(options);
    }
    else{
        console.log("error")
    }


    const respStore = await DOMAIN.get('stores');
    if (respStore.result.length > 0) {

        const options = [{key: 0, label: "Select Route", value: ''}];
        respStore.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.flightNumber} (${fieldValue.originName}-${fieldValue.destinationName})`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setStores(options);
    }
    else{
        console.log("error")
    }


} catch (error) {

}

}
else{
  try {
    const resp = await DOMAIN.get('reports/crewReportTypes');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: "Select Report Type", value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setReportTypes(options);
    }
    else{
        console.log("error")
    }


} catch (error) {

}
}
setShowDownload(true)
setCursorDisabled(false);

        }

const onDownloadReportFinal=async()=>{
  if(reptType==='Vendor Mapping Report'||reptType==='Price Master Report'){
    onDownloadItemMaster(reptType);
    return;
  }
if(reportsSelected!=='Crew Commission Summary Report' && reportsSelected!=='Crew Commission Report' && reportsSelected!=='Crew Stock Variance Report' && reportsSelected!=='Customer Interactions Report' &&  reportsSelected!=='Crew Reconciliation Variance Report'){
    const body={
    startDate: reportDate.startDate,
    endDate: reportDate.endDate,
    reportType: reptType,
    ...(storeType?.length > 0 && reportsSelected!=='Consignment Fillup' && reportsSelected!=='Consignment Sales' && reportsSelected!=='Consignment Returns' && { storeId: storeType[0]?.value })
}

    let header={
      'Accept':'text/csv'
    }
        try {
        const res= await DOMAIN.post(`sales/reports`,body,header);
        if(res.status==='scheduled'){
          checkDownloadStatus(res.id, null);
        }
        }
         catch (error) {
          setIsDownloading(false)
         }
}else{

  let body = {
    startDate: reportDate.startDate,
    endDate: reportDate.endDate,
    reportType: reptType,
  };

  switch (reptType) {
    case 'crewCommission':
    case 'crewVariance':
    case 'crewReconVariance':
      body.crewCode = getCrewName(crewName);
      break;
    case 'customerInteractionsReport':
      // Null check to prevent undefined error when crew details are not selected 
      body.crewCode = optionSelectedCrew?.[0]?.key && optionSelectedCrew?.[0]?.key===null?optionSelectedCrew?.[0]?.value:optionSelectedCrew?.map(crew => crew.value);
      body.sectors = optionSelectedSector?.[0]?.key && optionSelectedSector?.[0]?.key===null?optionSelectedSector?.[0]?.value:optionSelectedSector?.map(sect => sect.value);
      break;
    case 'allCrewCommission':
      break;
    default:
      break;
  }


  let header = {
    Accept: "text/csv",
  };
  if(body && reptType){
       try {
    setIsDownloading(true);
    const res = await DOMAIN.post(`crew/download/${reptType}`, body, header);
    if (res.status === "scheduled") {
      checkDownloadStatus(res.id, null);
    }
  } catch (error) {
    setIsDownloading(false);
  }
  }



}

}
const onDownloadActivityReport=async(e)=>{
  let header={
    'Accept':'text/csv'
  }
      try {
      const res= await DOMAIN.post(`devices/activityReport`,{},header);

      if(res.status==='scheduled'){
        checkDownloadStatus(res.id, null);

      }
      }
       catch (error) {


       }
    }

    const onDownloadAircraftOpn=async(e)=>{
      let header={
        'Accept':'text/csv'
      }
          try {
          const res= await DOMAIN.post(`aircrafts/operationStats`,{},header);
          if(res.status==='scheduled'){
            checkDownloadStatus(res.id, null);

          }
          }
           catch (error) {


           }
    }
const onActionInner = (action, row) => {
  let updatedEditFields = [];
  setModalTitle('Download Reports');
  const commonFields = [
    {
      key: 1,
      label: 'Report Type',
      name: 'reportType',
      id: 'reportType',
      attribute: 'reportType',
      type: 'select',
      required: true,
      className: 'select-search-cls',
      options: reportTypes,
      disabled: true,
    },
    {
      key: 2,
      label: 'Start Date',
      name: 'startDate',
      id: 'startDate',
      attribute: 'startDate',
      type: 'date',
      required: true,
      disabled: false,
      placeholder: t('datePickerPlaceholder'),
      className: 'date-input',
    },
    {
      key: 3,
      label: 'End Date',
      name: 'endDate',
      id: 'endDate',
      attribute: 'endDate',
      type: 'date',
      required: true,
      disabled: false,
      placeholder: t('datePickerPlaceholder'),
      className: 'date-input',
    },
  ];

  if (action.value === 'downloadPOReportsPopup' && row !=='Item Stock Movement' && row !=='LOI Balance Report' && row !=='PO vs GRN Report (Active PO)' ) {

    updatedEditFields = [
      ...commonFields,
      {
        key: 4,
        label: 'Select Warehouses',
        name: 'selectWarehouses',
        id: 'selectWarehouses',
        attribute: 'selectWarehouses',
        type: 'rcSelectAll',
        disabled: false,
        required: true,
        className: 'select-search-cls',
        options: warehouses,
      },
    ];
  } else if(row && row ==='Item Stock Movement') {
    updatedEditFields = [
      ...commonFields,
      {
        key: 4,
        label: 'Select Item',
        name: 'selectItems',
        id: 'selectItems',
        attribute: 'selectItems',
        type: 'selectSearch2',
        disabled: false,
        required: true,
        className: 'select-search-cls',
        options: items,
      },
    ];
  }
  else if(row && row ==='LOI Balance Report') {
    updatedEditFields = [
      {
        key: 1,
        label: 'Report Type',
        name: 'reportType',
        id: 'reportType',
        attribute: 'reportType',
        type: 'select',
        required: true,
        className: 'select-search-cls',
        options: reportTypes,
        disabled: true,
      },
    ];
  }
  else if(row && row ==='PO vs GRN Report (Active PO)') {
    updatedEditFields = [
      {
        key: 1,
        label: 'Report Type',
        name: 'reportType',
        id: 'reportType',
        attribute: 'reportType',
        type: 'select',
        required: true,
        className: 'select-search-cls',
        options: reportTypes,
        disabled: true,
      },
      {
        key: 2,
        label: 'Select Warehouses',
        name: 'selectWarehouses',
        id: 'selectWarehouses',
        attribute: 'selectWarehouses',
        type: 'rcSelectAll',
        disabled: false,
        required: true,
        className: 'select-search-cls',
        options: warehouses,
      },
    ];
  }

  setModalCustomButtons([

    { label: 'Download', attribute: 'button', type: 'button', disabled: false, className: 'submit-button'
        , action: 'onSubmit', loadingStateLabel: 'Processing...'
    }
]);
  setEditFormFields( updatedEditFields );

  setState((_prev) => {
      return { ..._prev, selected: { ...row, action: action.value} };
  });
};



const onActionInnerVendMapp = (action, row) => {
  let updatedEditFields = [];
 if (action.value === 'vendorMapping') {

      setModalTitle('Download Vendor Reports');

      updatedEditFields = [
          { key: 1, label: 'Select Warehouses', name: 'selectWarehouses', id: 'selectWarehouses', attribute: 'selectWarehouses', type: 'rcSelectAll', disabled: false,
              required: true, className: 'select-search-cls',
              options: warehouses
          },

      ];
      setModalCustomButtons([

          { label: 'Download', attribute: 'button', type: 'button', disabled: false, className: 'submit-button'
              , action: 'onSubmit', loadingStateLabel: 'Processing...'
          }
      ]);

  }
  setEditFormFields( updatedEditFields );

  setState((_prev) => {
      return { ..._prev, selected: { ...row, action: action.value} };
  });
};


const getWarehouses = useCallback(async () => {
    try {
    const resp = await DOMAIN.get('warehouses');
    if (resp.result.length > 0) {
        const options = [];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setWarehouses(options);
    }
    } catch (error) {

    }

  },[])
  const fetchPriceList = useCallback(async () => {
    try {
    const resp = await DOMAIN.get('items/price-list');
    if (resp.success && resp.result.length > 0) {
        const options = [];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue}`, value: `${fieldValue}`});
          return fieldValue;
        });
        setPriceLists(options);
        return true;
    }
    } catch (error) {
return false;
    }

  },[])

  const getAllItems = useCallback(async () => {
    try {
    const resp = await DOMAIN.get('items/all');
    if (resp.result.length > 0) {
        const options = [];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.id}`});
          return fieldValue;
        });
        setItems(options);
    }
    } catch (error) {

    }

  },[])

const getCrewDetails=useCallback( async () => {
    const resp = await DOMAIN.get('sandboxing/employees?includeAdmin=no');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: "Select Crew", value: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: fieldValue.employeeId, label: `${fieldValue.employeeName} (${fieldValue.employeeCode}) ${index}`, value: `${fieldValue.employeeCode}`});
          return fieldValue;
        });
        setCrewMembers(options.filter((item,index,self)=>index===self.findIndex(i=>(i.key===item.key && i.value===item.value))));
    }
    const resp3 = await DOMAIN.get('stores');
    if (resp3.result.length > 0) {
        const options = [{key: 0, label: "Select Sectors", value: ''}];
        resp3.result.filter( (fieldValue, index) => {
          options.push({key: fieldValue.id, label: `${fieldValue.flightNumber} (${fieldValue.originName}-${fieldValue.destinationName}) ${fieldValue.id}`, value: `${fieldValue.value}`});
              return fieldValue;
            });
            setSectors(options.filter((item,index,self)=>index===self.findIndex(i=>(i.key===item.key && i.value===item.value))));
    }
  },[])

  const getSectorList =useCallback(async() => {
    try {
           const resp= await APIEndpoint.get('stores')
            const list = [];
            if (resp.success) {
              // eslint-disable-next-line array-callback-return
              resp.result.map((_) => {
                list.push({ value: _.id, id: _.id, label: _.value });
              });

              setSectorsList(list);
            }


    } catch (error) {

    }

    return false;
  },[])

  const updateEditFormValues = async (e, updatedFormObj) => {

    ReactDOM.flushSync( () => {
        if (e) {
            const selectedDistributor = reportTypes.find( item => item.value === e);

            /** Set to respective fields */
            const updatedEditFields = editFormFields.filter( (field) => {

                if (selectedDistributor ) {
                    if ( field.attribute === 'reportType' ) {
                        field.value = selectedDistributor.label;
                    }
                }

                return field;

            });

            setEditFormFields( _prev => {
                return [ ...updatedEditFields ] ;
            });
        }
    })


};


  const loadReportTypes = useCallback(async () => {
    try {
       const resp = await APIEndpoint.get('warehousereports/warehousereportTypes');
    if (resp.result.length > 0) {
        const options = [{key: 0, label: preCompile.selectReportType, value: '', id: ''}];
        resp.result.filter( (fieldValue, index) => {
          options.push({key: index+1, label: `${fieldValue.value}`, value: `${fieldValue.value}`, id: `${fieldValue.id}`});

          return fieldValue;
        });

        setReportTypesWareHouse(options);
    }
    } catch (error) {

    }

},[])

  const onDateChange=(e)=>{
    let date = e.target.value;
    setEstimateDate(date);
    fetchUpliftEstimates(date);
  }

  const onItemTypeChange = (e) => {
    if(reptType==='Vendor Mapping Report' && typeof e==='object'){
       setSelWarehouse(e);
    }else{
      setSelWarehouse(e.target.value);
      fetchUpliftEstimates(e.target.value);
    }
  }

  const handleChange = (selected) => {
    setOptionSelectedCrew(selected)
  };

  const handleChangeSector = (selected) => {
    setOptionSelectedSector(selected)
  };

  const filterData = {
    action: 4,
    collection: '',
    filterOperation: 'or',
    filters: [],
    limit: 50,
    page: 1,
  };

  const fetchUpliftEstimates = async () => {
    filterData.page = 1;
    filterData.limit = 50;
    filterData.filters = [{targetDate: moment(estimateDate).format('YYYY-MM-DD[T]HH:mm:ss')}, {warehouseId: Number(selWarehouse)}];
    const res = await DOMAIN.post('estimates/getUpliftEstimates', filterData);
    setResponse(res?.success);
    return res;
  }

  const onDownloadDistributors=async(e)=>{
    let header={
      'Accept':'text/csv'
    }
    try {
    const res= await APIEndpoint.post(`downloads/distributorMaster`,{reportType: "Distributors"},header);
    if(res.status==='scheduled'){
      checkDownloadStatus(res.id, null);
    }
    }
      catch (error) {

      }
  }

  const onDownloadSectors=async(e)=>{
    let header={
      'Accept':'text/csv'
    }
    try {
    const res= await APIEndpoint.post(`downloads/routes`,{reportType: "sectors"},header);
    if(res.status==='scheduled'){

      checkDownloadStatus(res.id, e);
    }
    }
      catch (error) {


       
      }
  }


  const onDownloadUsers=async(e)=>{
    let header={
      'Accept':'text/csv'
    }
        try {
        const res= await DOMAIN.post(`employees/activeUsers`,{},header);
        if(res.status==='scheduled'){
          checkDownloadStatus(res.id, e);
        }
        }
         catch (error) {


          setState((_) => {
            return { ..._,message:{text:error?.data?.message||"Something went wrong!"},};
          })
          setTimeout(() => {
            setState((prevState) => ({
              ...prevState,
              message: null,
            }));
          }, 5000);
         }
      }



  const onDownloadPriceList=async(e)=>{
    let header={
      'Accept':'text/csv'
    }
    try {
    const date = new Date().toISOString()
    let request_payload = {
      startDate: date,
      endDate: date,
      listName: state.filterPrice
    }
    const res= await DOMAIN.post(`downloads/priceList`,request_payload,header);
    if(res.status==='scheduled'){
      checkDownloadStatus(res.id, e);
    }
    }
      catch (error) {
        setIsDownloading(false)
      }
  }





  const handleDownloadReportBtn = async () => {
    setCursorDisabled(true);

    try {
      const [cashierReportTypesRes, cashDrawersRes] = await Promise.all([
        APIEndpoint.get('reports/cashierReportTypes'),
        APIEndpoint.get('cashRegister/cashDrawers')
      ]);

      const cashierReportTypesList = cashierReportTypesRes.result.map(item => ({label: item.value,value: item.id}));
      cashierReportTypesList.unshift({ label: t('pages.cashRegisterContent.cashDeposits.cashReportPlaceholder'), value: "" });

      const cashDrawerDownloadList = cashDrawersRes.result.map((item, index) => ({key: index,label: item.value,value: item.id}));
      cashDrawerDownloadList.unshift({ label: t('pages.cashRegisterContent.cashDrawer.selectPlaceholder'), value: '' });

      setState(prevState => ({
        ...prevState,
        showActionDialog: 'report',
        cashReportTypes: cashierReportTypesList,
        cashDrawerDownload: cashDrawerDownloadList
      }));
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleDownloadReportSubmit = async (e,updated) => {

if(!viewReports || !downloadReports)return;
    updated={...updated,reportType:reptTypeCash,startDate:updated && updated.startDate?updated.startDate:ReportFields[1].value,endDate:updated && updated.endDate?updated.endDate:ReportFields[2].value}

    let valid = ReportFields.some((_) => {
       return updated[_.attribute]
     })

     if (valid) {
       setState((prevState) => ({
         ...prevState,
         showAPILoading: true,
       }));

         let body ={}
         if(!updated.cashDrawer){
          body= {
             endDate:formatDateByTimezone(new Date(updated.endDate),true),
             reportType: updated.reportType,
             startDate:formatDateByTimezone(new Date(updated.startDate),true)
           }
         }else{
           body= {
             endDate:formatDateByTimezone(new Date(updated.endDate),true),
             reportType: updated.reportType,
             cashDrawerId:updated.cashDrawer,
             startDate:formatDateByTimezone(new Date(updated.startDate),true)
           }
         }
   let header={
         'Accept':'text/csv'
       }
      try {

             const res= await DOMAIN.post('cashier/download/' + body.reportType, body,header);

           if(res.status==='scheduled'){
             checkDownloadStatus(res.id, null);
           }
           }
            catch (error) {
              setIsDownloading(false)
             setState((_) => {
               return { ..._,message:{text:error?.data?.message},};
             })
             setTimeout(() => {
               setState((prevState) => ({
                 ...prevState,
                 message: null,
                 actionDialogData: null,showAPILoading:false
               }));
             }, 5000);
            }


     }

   }

  const onDownloadCombo=async()=>{
    let header={
      'Accept':'text/csv'
    }
    try {
    const res= await APIEndpoint.post(`sales/reports`,{reportType: "comboItemMaster"},header);
    if(res.status==='scheduled'){
      checkDownloadStatus(res.id, null);
    }
    }
      catch (error) {
        setIsDownloading(false)

      }
  }


  const onDownloadItemMaster=async(tp)=>{
    let header={
      'Accept':'text/csv'
    }
    const downloadType = (tp==='Item Master Report'||tp==='Meal Master Report')?'downloads/itemMaster':tp==='Aircraft Operation Status Report'?'aircrafts/operationStats':tp==='Combo Report'?'sales/reports':tp==='Sectors Report'?'downloads/routes':tp==='BPA Report'?'downloads/distributorMaster':tp==='Vendor Report'?'downloads/vendorMaster':tp==='Active Users Report'?'employees/activeUsers':tp==='User Accounts Report'?'userAccounts/activeUsers':tp==='Vendor Mapping Report'?'downloads/vendorMasterMappings':tp==='Price Master Report'?'downloads/priceList':null;
        try {
            const datePriceList = new Date().toISOString();
            const data = downloadType === 'sales/reports' 
    ? { reportType: "comboItemMaster" } :downloadType==='downloads/vendorMasterMappings'?{
    "warehouseId": selWarehouse?.key,
    "storeId": null
}
    :downloadType==='downloads/priceList'?{
    "startDate":datePriceList ,
    "endDate":datePriceList ,
    "listName": selWarehouse[0]?.value??null
} :{};
        const res= await DOMAIN.post(`${downloadType}`,data,header);
        if(res.status==='scheduled'){
          setIsDownloading(true)
          checkDownloadStatus(res.id, null);
        }
        }
         catch (error) {
          setIsDownloading(false)
          setCursorDisabled(false);

          setState((_) => {
            return { ..._,message:{text:error?.data?.message},};
          })
          setTimeout(() => {
            setState((prevState) => ({
              ...prevState,
              message: null,
            }));
          }, 5000);
         }
      }


      const handleModalCancel = () => {
        setState((_) => ({ ..._, showActionDialog: null, actionDialogData: null,showAPILoading:false }))
        setReportFields(ReportFields);
      }

  const onUploadClose = () => {
    setShowDownload(false);
    setReptType("");
    setStoreType("");
    setSelWarehouse("");
  setReportDate({startDate:"",endDate:""});
    setShowUpload(false);
    setCrewName([]);
    setOptionSelectedCrew([]);
    setOptionSelectedSector([]);
    setReptType("");
    setReportSelected("");
    setReportDownloadErr(null);
  };
  const onClose = (e, action, row) => {
    setShowDownload(false);
    setEditFormFields([]);
    setIsDownloadPressed(false);
    setReptType("");
    setStoreType("");
    setReportDate({startDate:"",endDate:""});
    setShowUpload(false);
    setCrewName([]);
    setModalFormData({});
    setOptionSelectedCrew([]);
    setOptionSelectedSector([]);
    setReptType("");
    setReportDownloadErr(null);
    setModalFormStatusObj({ text: '' });
    setState((_prev) => {
      return { ..._prev, selected: false };
  });
};


const validateFormInputs = (body, frm='Suspend') => {
  if (!body) {
      setModalFormStatusObj({ error: 'Input validation failed!' });
      return false;
  }

  if ( frm ==='Suspend' ) {
      if (!body.remarks) {
          setModalFormStatusObj({ error: 'Please enter remarks.' });
          return false;
      }
  }

  if ( frm ==='downloadPOReportsPopup' ) {
      if (!body.reportType) {
          setModalFormStatusObj({ error: 'Please select warehouse report type.' });
          return false;
      }
      else if ((!body.startDate || !body.endDate) && body.reportType!=='LOI Balance Report' && body.reportType!=='PO vs GRN Report (Active PO)') {
          setModalFormStatusObj({ error: 'Please select start date & end date.' });
          return false;
      }
      else if ( (!body.selectWarehouses || !body.selectWarehouses.length) && body.reportType!=='Item Stock Movement'  && body.reportType!=='LOI Balance Report') {
          setModalFormStatusObj({ error: `Please select warehouses.` });
          return false;
      }
      else if (body.reportType==='Item Stock Movement' && !body.itemId) {
        setModalFormStatusObj({ error: `Please select an Item.` });
        return false;
    }
      else{
        setModalFormStatusObj({ text: ''});
        return true;
      }
  }
  return true;
};

const onWarehouseChange=(updated)=>{
  let newUpdates = modalFormData ? { ...modalFormData } : {}
  if(updated && Array.isArray(updated)){
    newUpdates['selectWarehouses'] = updated.map(wr=>wr.value) ?? [];
  }else{
    newUpdates['itemId'] = Number(updated.selectItems);
  }

  setModalFormData((_)=>({..._,...newUpdates}));
}


const onModalFormInputChange = (e, newFormData) => {
  const { name, value } = e.target;
  let newUpdates = modalFormData ? { ...modalFormData } : {}
  newUpdates[name] = value;

  setModalFormData((_)=>( {...newFormData,..._ }) );
}

const onSubmit = async (e, updated) => {

  if(e){
    setIsDownloadPressed(true)
  }

  if (updated) {
    if (!updated.reportType) {
      updated.reportType = reportsSelected;
    }
  } else {
    updated = { reportType: reportsSelected };
  }

  if(modalFormData){
    updated={...updated,...modalFormData}
  }

  try {

       if( state.selected.action === 'downloadPOReportsPopup' ) {
          if (!validateFormInputs(updated, 'downloadPOReportsPopup') ) {
              updateButtonTxtStatus(true, e, 'Download', false);
              return false;
          }

          try {
              const reportTypeObj = reportTypes.find( row => updated.reportType === row.value);
              if ( !reportTypeObj ) {
                  setModalFormStatusObj({ error: 'Invalid report type selected, Please check.' });
                  updateButtonTxtStatus(true, e, 'Download', false);
                  return false;
              }

              const downloadPayload = {
                 ...(updated.startDate? {startDate: formatDateByTimezone((updated.startDate))}:{startDate:formatDateByTimezone(new Date(),true)}),
                 ...(updated.endDate? {endDate: formatDateByTimezone((updated.endDate))}:{endDate:formatDateByTimezone(new Date(),true)}),
                  warehousereportType: reportTypeObj.id,
                  ...(updated.itemId
                    ? { itemId: updated.itemId }:updated.selectWarehouses?
                    { warehouseId: updated.selectWarehouses }:{})
              };

              APIEndpoint.post('warehouse/reports', downloadPayload, { Accept: MIMETypes.csv }).then( resp => {

                  if (resp.status === 'scheduled') {
                    setIsDownloading(true)
                    checkDownloadStatus(resp.id, null);

                  } else {
                      updateButtonTxtStatus(true, e, 'Download', false);
                  }

              })
              .catch( error => {
                  updateButtonTxtStatus(false, e, 'Download failed', false);
              });
          }
          catch( er ) {
          }
      }
      if(state.selected.action === 'vendorMapping'){
        onDownloadVendorMappingSubmit()
      }

  }
  catch(err) {
    // setModalFormStatusObj({ error: 'Error: ' + err.data.msg });
  }
};
const getWarehousesDetails=()=>{
  if(modalFormData){
      const wareHs=  warehouses.find(w=>w.value===modalFormData?.selectWarehouses)
      return wareHs?.value;
    }

};


const onDownloadVendorMappingSubmit=async()=>{
  let header={
    'Accept':'text/csv'
  }
 let body={
      "warehouseId": getWarehousesDetails(),
      "storeId": null
  }

      try {
      const res= await DOMAIN.post(`downloads/vendorMasterMappings`,{body},header);
      if(res.status==='scheduled'){
        checkDownloadStatus(res.id, null);
      }
      }
       catch (error) {
        setIsDownloading(false)
       }
    }

const checkDownloadStatus = async (jobId, e) => {
setIsDownloading(true);
  await APIEndpoint.get('downloads/status/' + jobId).then( resp => {

      if (resp.status === 'completed') {
        setIsDownloading(true)

          clearTimeout(timeout)
          // updateButtonTxtStatus(true, e, 'Downloaded', false);

          // https://dfp.ngopos.com/api/downloads/analytics/PO%20vs%20GRN%20Report-2022-12-19T19-33--56c0695a-604a-4a38-9097-b8b815063e68.csv

          onDownloadCSVFile('downloads/analytics/' + resp.fileName + resp.fileExtension,  resp.fileName);
          if(e){
            updateButtonTxtStatus(true, e, 'Downloaded', false, { defaultButtonText: 'Download' });
          }

          setState((_prev) => {
              return { ..._prev, selected: false };
          });
          setModalFormData({});
          setIsDownloadPressed(false);
          setModalFormStatusObj({ text: '' });
          setIsDownloading(false)


      }
      else {

          timeout = setTimeout(() => {
            setIsDownloading(false)


              checkDownloadStatus(jobId, e);
          }, 5000);
      }

  }).catch( error => {
    setIsDownloading(false)
      updateButtonTxtStatus(false, e, 'Download failed', false);
  });
};

  const handleSelectPriceList = (e) => {
    setSelWarehouse([e]??null)
  }

const handleOnchangeReports=(selectedValue,data,obj)=>{
  const {reportType}=data;
  if(reportType==="cashierBankTransferReport"){
  setReportFields((prev)=>{
  const cashDrawExist=prev.some(item=>item.attribute==='cashDrawer')
  if(!cashDrawExist){
  return [...prev,{ label: 'Select Station', attribute: 'cashDrawer', type: 'select', required: true }]

  }else{
  return prev

  }

  }

  )
  }
  else{
    setReportFields((prev) => {
      return prev.map((field) => {
        if (field.attribute === 'startDate' && data.startDate) {
          return { ...field, value: new Date(data.startDate) };
        }
        if (field.attribute === 'endDate' && data.endDate) {
          return {
            ...field,value: new Date(data.endDate),minDate: new Date(data.startDate) || null};
        }
        if (field.attribute === 'endDate' && data.startDate && !data.endDate) {
          const startDate = new Date(data.startDate);
          const today = new Date();
          if (startDate <= today) {
            return {...field,value: today,minDate: startDate};
          } else {
            return {...field,value: startDate,minDate: startDate,
            };
          }
        }
        return field;
      });
    });

  }
}

const applyBorderBottom = (index, id) => {
  if (!rowsWithBorderBottom || rowsWithBorderBottom.length === 0) return false;
  
    return rowsWithBorderBottom.includes(index+1);
  
 
};

const renderTableRows = () => {
  if (reportOptionsFiltered.length === 0) {
    return (
      <tr>
        <td colSpan={2}>
          <div style={{ margin: '2rem' }} className="dialog__body_container font-weight-margin flexCol alignItemsCenter justifyContentCenter flexWrap">
            No Data
          </div>
        </td>
      </tr>
    );
  }

  return reportOptionsFiltered.map((_, index) => {
    const borderBottomStyle = applyBorderBottom(index, _.id) ? '1px solid #03354aff' : 'none';

    return (
      <tr key={_.id}>
        <td className="custom-table-td" style={{ borderBottom: borderBottomStyle }}>
          {getMenuGroups(_.menu)}
        </td>
        {viewReports ? (
          <td style={{ backgroundColor: `${!Number(index%2)?"#1e3544":"#0c2636"}`, color: '#fff' }}>
            <span
              title={`Download ${(cursorDisabled || _.disabled) ? 'Not Available' : _.reportsType}`}
              onClick={() => onDownloadReports(_)}
              className={(cursorDisabled || _.disabled) ? "reports-download cursor-disabled" : "reports-download"}
            >
              {_.reportsType}
            </span>
          </td>
        ) : null}
      </tr>
    );
  });
};

    return (
        <>
       <div className="container-fluid dashboard-summary-container"  style={{ overflowY: "scroll", maxHeight: "94vh"}}>
       <div ref={markerRef} style={{ height: '1px' }}></div>
            <div className='table-header' style={{ overflowY: "scroll",width:"49.6%",marginLeft:'25%'}}></div>
              <div className="flexRow justifyContentCenter alignItemsCenter sm-scrollbar" style={{ overflowY: "scroll",width:"50%",marginLeft:'25%'}}>
              <table className="custom-table custom-table-td">
          <thead>
            <tr>
              <th colSpan="2" style={{borderTop:'none',textAlign: 'center',backgroundColor:'#1d3f4f'}}>Download Reports</th>
            </tr>
            </thead>
             {Boolean(permissionObj) && renderTableRows()}
          </table></div>


      </div>


      {showUpload &&
        <div className="overlay" role="dialog">
          <div className="dialog sm-scrollbar">
            <div className="dialog__content">
              <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={onUploadClose} />
              <h2 className="dialog__title subheading-text-medium fontMedium">{(reptType.length>0 && reptType==='Vendor Mapping Report')?'Download Vendor Mapping Report':(reptType.length>0 && reptType==='Price Master Report')?'Download Price Master':'Download Estimates'}</h2>
              <hr />

                <div className="dialog__body_container flexRow mt-4 button-align justifyContentFlexEnd flexWrap">
                <div className={`dialog__container_item input-container`}>
            {(!reptType.length && reptType !=='Vendor Mapping Report' && reptType !=='Price Master Report')  ?  <div className={`dialog__description`}>
                  <> <label className={`textAlignLeft fontRegular req`}>Effective Date</label>
                    <NGODatePicker
                      style={{width: '17rem'}}
                      isclearable={false}
                      value={estimateDate}
                      placeholder={t('effectiveDate')}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChange} />
                  </>
                </div>:null}
                <>
                
             { (reptType.length && reptType !=='Price Master Report')  ? <> <label  className={`flexRow textAlignLeft sub-heading-title-req margBottom10`}>Select Warehouse</label>
              <Select
              options={warehouses}
              value={warehouses?.filter(it=>it.label===selWarehouse?.label)}
              onMenuOpen={handleMenuOpen}
              onMenuClose={handleMenuClose}
              onChange={onItemTypeChange}
              styles={newCustomStyles}
              placeholder="Search Warehouse"
              isSearchable={true}
              isClearable={true}
            /></>:<></>}
  
                </>
                { (reptType.length && reptType ==='Price Master Report')  ? <> 
                <button className='flexRow justifyContentFlexEnd saleType-div margRight'>
              <CustomSelect
                options={priceLists??[]}
                placeHolder="Search Price List"
                width={'17rem'}
                value={selWarehouse}
                onChange={handleSelectPriceList}
              />
              </button></>:<></>}

                <button type="button" onClick={onDownloadReportFinal} disabled={state.disabled} className="btn btn-info mt-4" style={{ color: "white",width:"100%" }}>
                 { Boolean(isDownloading)?<div className='flexRow justifyContentCenter alignItemsCenter'><img src={LoadingIn} style={{marginRight:'5px',width:'25px',height:'25px'}} alt="Loading" /> Processing...</div>:<><span><img className="icon-size mt-1" alt='downloadMaster' src={downloadMasterIcon} /></span> Download</>}
               </button>

              </div>
                  <div className="col-md-4 col-xs-12">
                  </div>
                </div>
            </div>
          </div>
        </div>
      }



      {
       state&& state.showActionDialog === 'report' && reportsFields.length &&
        <EditModal
          showDone={false}
          className='cash-sector-add'
          showFieldsInColumn={true}
          modalFormStatusObj={modalFormStatusObj}
          onChange={handleOnchangeReports}
          showLoadingBtn={state.showAPILoading}
          title={t('pages.cashRegisterContent.cashDeposits.downloadReportTitle')}
          fields={reportsFields?.map((_) => {
            if(_.label!=='Select Station'&&_.attribute!=='reportType'){
              return { ..._, options: state.cashReportTypes, initialValue: ''}

            }
            else if(_.attribute==='reportType'){
              return { ..._, options: state.cashReportTypes, initialValue: '',value:reptTypeCash}

            }
            else {
              return { ..._, options: state.cashDrawerDownload, initialValue: ''}
            }
          })}
          onSubmit={handleDownloadReportSubmit}
          onClose={handleModalCancel}>

        </EditModal>
      }


      {state &&
      Boolean(state.selected) &&
      state.selected?.action === "downloadReportPopup" ? (
        <>
          <SalesReportsDownloadComponent
            sectorList={sectorList}
            reportSel={reportsSelected}
            setIsDownloading={setIsDownloading}
            onClose={() => {
              onClose();
            }}
            checkDownloadStatus={checkDownloadStatus}
          />
        </>
      ) : null}

      {
                    state && Boolean(state.selected)&&state.selected.action === 'downloadPOReportsPopup' ? (
                        <EditModal
                            title={ modalTitle }
                            customModalStyle={ modelStyle }
                            className="report-font"
                            onClose={onClose}
                            onSubmit={onSubmit}
                            modalFormStatusObj={modalFormStatusObj}
                            modalCustomButtons={modalCustomButtons}
                            showLoadingBtn={isDownloading}
                            fields={ editFormFields.map( (elt) => {
                                    if (state.selected.action === 'downloadPOReportsPopup' ) {
                                      if(elt.attribute==="reportType"){
                                        return {...elt, initialValue:reptTypeProcurement}
                                      }else{return {...elt, initialValue: state.selected[elt.attribute] || ''}}

                                    }
                                    else {
                                        return {...elt, initialValue: '' }
                                    }
                                })
                            }
                            showFieldsInColumn={true}

                            onChange={ (e,updated) => {
                            setModalFormStatusObj({text:""});

                                    setUpdatedFormFieldValues(updated);
                                    if (typeof e === 'string') { // Search select
                                        updateEditFormValues(e, updated);
                                    }
                                   else if(!e && updated){
                                      onWarehouseChange(updated)
                                    }
                                    else {
                                        onModalFormInputChange(e, updated);
                                    }

                                }
                            }
                        />
                    )
                    : null
                }

      {
                    state && Boolean(state.selected)&&state.selected.action === 'vendorMapping' ? (
                        <EditModal
                            title={ modalTitle }
                            customModalStyle={ modelStyle }
                            onClose={onClose}
                            onSubmit={onSubmit}
                            modalFormStatusObj={modalFormStatusObj}
                            modalCustomButtons={modalCustomButtons}
                            fields={ editFormFields.map( (elt) => {
                                    if (state.selected.action === 'vendorMapping' ) {
                                        return {...elt, initialValue: state.selected[elt.attribute] || ''}
                                    }
                                    else {
                                        return {...elt, initialValue: '' }
                                    }
                                })
                            }
                            showFieldsInColumn={true}

                            onChange={ (e, updated) => {
                                    setUpdatedFormFieldValues(updated);

                                    if (typeof e === 'string') { // Search select
                                        updateEditFormValues(e, updated);
                                    }
                                    else {
                                        onModalFormInputChange(e, updated);
                                    }

                                }
                            }
                        />
                    )
                    : null
                }

                 {/* {
                    state && Boolean(state.selected)&&state.selected.action === 'vendorMapping' ? (
                        <EditModal
                            title={ modalTitle }
                            customModalStyle={ modelStyle }
                            onClose={onClose}
                            onSubmit={onSubmit}
                            modalFormStatusObj={modalFormStatusObj}
                            modalCustomButtons={modalCustomButtons}
                            fields={ editFormFields.map( (elt) => {
                                    if (state.selected.action === 'vendorMapping' ) {
                                        return {...elt, initialValue: state.selected[elt.attribute] || ''}
                                    }
                                    else {
                                        return {...elt, initialValue: '' }
                                    }
                                })
                            }
                            showFieldsInColumn={true}

                            onChange={ (e, updated) => {
                                    setUpdatedFormFieldValues(updated);

                                    if (typeof e === 'string') { // Search select
                                        updateEditFormValues(e, updated);
                                    }
                                    else {
                                        onModalFormInputChange(e, updated);
                                    }

                                }
                            }
                        />
                    )
                    : null
                }
                 */}
      {showDownload && viewReports &&
        <div className="overlay" role="dialog">
          <div className="dialog sm-scrollbar">
            <div className="dialog__content">
              <img className="modal__close_icon" alt='Close' src={closeIcon} onClick={onUploadClose} />
              <h2 className="dialog__title subheading-text-medium fontMedium">Download reports</h2>
              <hr />

                <div className="dialog__body_container flexRow mt-4 button-align justifyContentFlexEnd flexWrap report-font">
                <div className={`dialog__container_item input-container`} style={{height:`${isDropdownOpen?'55vh':""}`}}>
                 <div className={`dialog__description`}>
                <label className={`textAlignLeft fontRegular req mt-2`}>Report Type</label>
                  <select className='select-input-galley1'
                  onChange={onReportTypeChange}
                  value={reptType||null}
                  >
                    {reportsType.map((_) => {
                      return (
                        <option disabled={true} value={_.value} key={_.value}>{_.label}</option>
                      )
                    })}
                  </select>
                  <div className=''>
                { reptType==="crewCommission"||reptType==="crewVariance" ||reptType==="crewReconVariance"?  <>
            <label  className={`flexRow textAlignLeft sub-heading-title-req margBottom10`}>Select Crew</label>
              <Select
              options={crewMembers}
              value={crewMembers?.filter(function (option) {
                return (
                  crewName.length && crewName[0]&&
                  crewName.find((sc) => sc.label === option.label)
                );
              })}
              onMenuOpen={handleMenuOpen}
              onMenuClose={handleMenuClose}
              onChange={onCrewChange}
              styles={newCustomStyles}
              placeholder="Search Crew"
              isSearchable={true}
              isClearable={true}
            /></> :<></> }
                </div>
                {   reptType==='customerInteractionsReport'?<div className={`dialog__container_item input-container`}>
         <div className={`dialog__description`}>
            <label  className={`flexRow textAlignLeft sub-heading-title-req margBottom10`}>Select Crew</label>
                <AllMultiSelect
                options={getOptions(crewMembers)}
                defaultValue={[]}
                isMulti
                styles={ {
                  input: provided => ({
                    ...provided,
                    color: '#fff'
                  })
                ,
                control: (defaultStyles) => ({
                  ...defaultStyles,
                  backgroundColor: "#162E3E",
                  width: '17rem',
                  boxShadow: "none",
                }),
                placeholder: (defaultStyles) => ({
                  ...defaultStyles,
                  textAlign: 'left',
                }), multiValue: provided => ({
                  ...provided,

                }),
                multiValueLabel: (provided,state) => ({
                  ...provided,
                  width: 'auto',
                  whiteSpace: 'nowrap',
                  overflow: 'visible',
                  title: state.data?.label,
                }), menu: provided => ({
                  ...provided,
                  backgroundColor: "#162E3E",
                  width: 'auto',
                  minWidth: '25rem',
                  maxWidth: '30rem',
                }),
                option: (provided, state) => ({
                  ...provided,
                  textAlign: 'left',
                  backgroundColor: state.isFocused ? '#1d3e4e' : 'transparent',
                  color: state.isFocused ? '#fff' : '#fff',
                  cursor: 'pointer',
                  '&:hover': {
                    backgroundColor: '#1d3e4e',
                    color: '#fff',
                  },
                })
              }
              }
              onMenuOpen={handleMenuOpen}
              onMenuClose={handleMenuClose}
                isSearchable
                isClearable
                components={{ Option, MultiValue }}
                onChange={handleChange}
                allowSelectAll={true}
                value={optionSelectedCrew}
                placeholder={`Select Crew`}

              />
              </div>
              </div>
          :<></>}
                <div className={`dialog__container_item input-container`}>
                <div className={`dialog__description`}>
                  <div className='flexCol margTop8 margBottm20'>
                  <> <label className={`textAlignLeft fontRegular req`}>Start Date</label>
                    <NGODatePicker
                      style={{width: '17rem'}}
                      value={reportDate.startDate}
                      name="startDate"
                      isclearable={true}
                      placeholder={t('Start Date')}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChangeRep} />
                  </>
                  </div>
                  <div className='flexCol margTop8 margBottm20'>
                   <> <label className={`textAlignLeft fontRegular req`}>End Date</label>
                    <NGODatePicker
                      style={{width: '17rem'}}
                      value={reportDate.endDate}
                      name="endDate"
                      disabled={!reportDate.startDate}
                      isclearable={true}
                      minDate={reportDate.startDate||null}
                      placeholder={t('End Date')}
                      placeholdertext={t('datePickerPlaceholder')}
                      onChange={onDateChangeRep} />
                  </></div>

                  {   reptType==='customerInteractionsReport'?<div className={`dialog__container_item input-container`}>
         <div className={`dialog__description`}>
            <label  className={`flexRow textAlignLeft sub-heading-title-req margBottom10`}>Select Sector</label>
              <AllMultiSelect
               options={getOptions(sectors)}
              defaultValue={[]}
              isMulti
              styles={ {
                input: provided => ({
                  ...provided,
                  color: '#fff'
                })
              ,
              control: (defaultStyles) => ({
                ...defaultStyles,
                backgroundColor: "#162E3E",
                width: '17rem',
                boxShadow: "none",
              }),
              placeholder: (defaultStyles) => ({
                ...defaultStyles,
                textAlign: 'left',
              }), multiValue: provided => ({
                ...provided,

              }),
              multiValueLabel: (provided,state) => ({
                ...provided,
                width: 'auto',
                whiteSpace: 'nowrap',
                overflow: 'visible',
                title: state.data.label,
              }), menu: provided => ({
                ...provided,
                backgroundColor: "#162E3E",
                width: 'auto',
                minWidth: '25rem',
                maxWidth: '30rem',
              }),
              option: (provided, state) => ({
                ...provided,
                textAlign: 'left',
                backgroundColor: state.isFocused ? '#1d3e4e' : 'transparent',
                color: state.isFocused ? '#fff' : '#fff',
                cursor: 'pointer',
                '&:hover': {
                  backgroundColor: '#1d3e4e',
                  color: '#fff',
                },
              })
            }
            }
            onMenuOpen={handleMenuOpen}
            onMenuClose={handleMenuClose}
              isSearchable
              components={{ Option, MultiValue }}
              onChange={handleChangeSector}
              allowSelectAll={true}
              value={optionSelectedSector}
              placeholder={`Select Sector`}

            />
            </div>
            </div>
      :<></>}
            { reptType==="sandboxSalesSummary"|| reptType==="sandboxInvoiceSummary"|| reptType==='offloadSummaryAggregate'|| reptType==="mealRefusedReport" || reptType==="upliftAuditReport" ||reptType==='upliftReport' ?  <><label className={`textAlignLeft fontRegular mt-2`}>Select Route</label>
                <Select
                  options={stores}
                  value={stores?.filter(function (option) {
                    return (
                      storeType.length && storeType[0]&&
                      storeType.find((sc) => sc.label === option.label)
                    );
                  })}
                  onMenuOpen={handleMenuOpen}
                  onMenuClose={handleMenuClose}
                  onChange={onStoreChange}
                  styles={customStyles}
                  placeholder="Search Route"
                  isSearchable={true}
                  isClearable={true}
                />

                </> :<></> }

                </div>


                </div>

                {reportDownloadErr && (
                  <div className='flexRow justifyContentCenter alignItemsCenter' style={{marginTop:"1.5rem",width:"100%"}}>
                    <p style={{width:"100%"}} className='listErrorMessagesCls'>{reportDownloadErr}</p>
                  </div>
                )}
             <button type="button" onClick={onDownloadReportFinal}  disabled={state.disabled} className="btn btn-info mt-4" style={{ color: "white", width: "100%" }}>
                {Boolean(isDownloading) ? (
                <div className='flexRow justifyContentCenter alignItemsCenter'><img src={LoadingIn} style={{ marginRight: '5px', width: '25px', height: '25px' }} alt="Loading"/> Processing...</div>
                ) : ( <span> <img className="icon-size mt-1" alt="downloadMaster" src={downloadMasterIcon}/>Download</span>)}</button>
                </div>
                </div>
                  <div className="col-md-4 col-xs-12">
                  </div>
                </div>
            </div>
          </div>
        </div>
      }

                {
                  !ready &&<div className='overlay_hide sub'></div>
                }


        </>

    );
}